// extracted by mini-css-extract-plugin
module.exports = {"nav":"style_nav__2Q2If","logo":"style_logo__97iLv"};